/**
 * Decodes the HTML entities that the API escapes in a comment body.
 *
 * The function decodes `&amp;` last. An earlier pass would turn an escaped
 * `&amp;lt;` into `<` instead of the literal text `&lt;`.
 */
export const decodeHtmlEntities = (value: string): string =>
  // &amp; &lt; &gt; &quot; &#x27; is the full set Django's escape() can emit (plus the &#39; apostrophe alias), so it is exhaustive by construction.
  value
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
